import { render, staticRenderFns } from "./insurance_payment.vue?vue&type=template&id=78223556&scoped=true&"
import script from "./insurance_payment.vue?vue&type=script&lang=js&"
export * from "./insurance_payment.vue?vue&type=script&lang=js&"
import style0 from "./insurance_payment.vue?vue&type=style&index=0&id=78223556&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78223556",
  null
  
)

export default component.exports